module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/8.b9c8d2c8.png";